import { YieldFetcher } from '../../types'

const INFINIFI_URL = 'https://eth-api.infinifi.xyz/api/protocol/data'

const siUSD = 'Staked infiniFi USD::siUSD'

export const infinifiFetcher: YieldFetcher = {
  label: 'InfiniFi',
  fetch: async () => {
    const res = await fetch(INFINIFI_URL).then((r) => r.json())

    const apy7d: number | undefined =
      res?.data?.stats?.staked?.average7dAPY
    if (apy7d === undefined) return { [siUSD]: 0 }

    // API returns decimal (0.0528 = 5.28%), multiply by 100 for 1 = 1%
    return { [siUSD]: apy7d * 100 }
  },
}
